<div class="content dark">
	<div class="row">
		<div class="col-md-12">
			<p>Download all firmware data across all assets. This can take a minute to generate.</p>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12 form-group">
			<label class="form-check-label">
				<input type="checkbox" [(ngModel)]="ignoreMyOrg">
				Ignore assets from {{api.user.organization_name}}
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<app-action-button [action]="DownloadFirmware" [context]="this" processing="Downloading..." complete="Downloaded" btnClass="btn-success">Download CSV</app-action-button>
		</div>
	</div>
</div>